import React from 'react';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';
import { whatsappNumber } from '../data/mockData';
import { useLanguage } from '../contexts/LanguageContext';

export const FinalCTA = () => {
  const { t } = useLanguage();

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(t('finalCta.whatsapp'));
    if (window.gtag) { window.gtag('event', 'whatsapp_click', { event_category: 'engagement', event_label: 'final_cta' }); }
    if (typeof window.fbq === 'function') { window.fbq('track', 'Contact', { content_name: 'final_cta' }); }
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  const benefits = t('finalCta.benefits');

  return (
    <section className="final-cta-section">
      <div className="container-custom">
        <div className="final-cta-content">
          <div className="cta-decoration top-left"></div>
          <div className="cta-decoration top-right"></div>
          <div className="cta-decoration bottom-left"></div>
          <div className="cta-decoration bottom-right"></div>

          <div className="cta-laurel-wreath">
            <svg width="80" height="50" viewBox="0 0 80 50" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 25C15 18 21 12 28 9C25 15 23 21 25 25C23 29 25 35 28 41C21 38 15 32 15 25Z" fill="currentColor" opacity="0.2"/>
              <path d="M65 25C65 18 59 12 52 9C55 15 57 21 55 25C57 29 55 35 52 41C59 38 65 32 65 25Z" fill="currentColor" opacity="0.2"/>
            </svg>
          </div>

          <div className="cta-text-content">
            <h2 className="cta-title">{t('finalCta.title')}</h2>
            <p className="cta-description">{t('finalCta.description')}</p>
          </div>

          <Button onClick={handleWhatsAppClick} className="cta-button" size="lg" data-testid="final-cta-btn">
            <MessageCircle className="mr-2 h-6 w-6" />
            {t('finalCta.button')}
          </Button>

          <div className="cta-benefits">
            {Array.isArray(benefits) && benefits.map((benefit, index) => (
              <div key={index} className="cta-benefit-item">
                <span className="benefit-check">✓</span>
                <span>{benefit}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
